import Footer from '../../common/components/List/Footer/index.js'
import {
  setLimit,
  setOffset,
  isLoadingSelector,
  stocktakeListQuerySelector,
  countSelector,
} from './stocktakeListFunctions.js'
import {useSelector} from '../../store.js'

export default function StocktakeListFooter() {
  const params = useSelector(stocktakeListQuerySelector)
  const isLoading = useSelector(isLoadingSelector)
  const count = useSelector(countSelector)

  return (
    <Footer
      isLoading={isLoading}
      limit={params.limit}
      offset={params.offset}
      count={count}
      setLimit={setLimit}
      setOffset={setOffset}
      preventResetOffset
    />
  )
}
